<div class="view-content">
  <div class="header">
    @if (!analysisRunning) {
      <button data-testing-id="start-test-run-btn" pButton [disabled]="!mayStartAnalysis" icon="true" type="button" style="width: 100%;" (click)="createSnapshot($event)" label="Create New Snapshot">
        <img src="assets/img/icons/analysis.svg"> <!-- todo -->
      </button>
    }
    @if (analysisRunning) {
      <button pButton type="button" style="width: 100%;" label="Analyzing..." icon="true">
        <fa-icon animation="spin" icon="sync-alt"></fa-icon>
      </button>
    }
  </div>
  @if (analysisError) {
    <div class="analysis-error" role="alert">
      <fa-icon icon="exclamation-triangle"></fa-icon>
      <span class="error-message">{{analysisError | json}}</span>
    </div>
  }
  @if (existingStatesDropdownItems && existingStatesDropdownItems.length > 0) {
    <div class="state-chooser">
      <p-select data-testing-id="issue-severity-dropdown" [options]="existingStatesDropdownItems" (onChange)="selectState($event['value'])"></p-select>
    </div>
  }
  @if (!!currentStateInfo) {
    <div class="state">
      @if (!stateIsLoading) {
        <div class="state-info"><div class="state-info-time">{{currentStateInfo.start | wmDateFormat:'YYYY-MM-DD HH:mm'}}</div><div class="state-name">{{getCurrentStateLabel()}}</div></div>
        @if (currentStateInfo.firstScreenshotThumbnailUrl) {
          <div class="screenshot"><img [src]="currentStateInfo.firstScreenshotThumbnailUrl"></div>
        }
        <div class="artifacts">
          @if (!!currentStateInfo && currentStateInfo.associatedArtifacts.size > 0) {
            <p-accordion [value]="currentStateInfo.associatedArtifacts[0]?.id">
              @for (fact of (currentStateInfo.associatedArtifacts || []); track fact) {
                <p-accordion-panel [value]="fact.id" [disabled]="fact.artifactType === 'Session.Video'"  (valueChange)="factTabHasChanged(fact.id)">
                  <p-accordion-header (click)="factTabHasChanged(fact.id)">
                    <div class="fact-header">
                      <div class="fact-title">{{'service.Fact.FactTypes.' + fact.artifactType | translate}}</div>
                    </div>
                  </p-accordion-header>
                  <p-accordion-content>
                    @if (artifacts[fact.id] === undefined) {
                      <div class="artifact-loading">
                        <fa-icon icon="spinner" animation="spin"></fa-icon>
                      </div>
                    }
                    @if (artifacts[fact.id] !== undefined) {
                      <div class="artifact-container">
                        @if (fact.artifactType === 'Session.Video') {
                          <div class="fact screenshot">
                            No preview available
                          </div>
                        }
                        @if (fact.artifactType === 'Page.Screenshot') {
                          <div class="fact screenshot">
                            <img [src]="makeScreenshotUrl(artifacts[fact.id]?.data['screenshotId'])">
                          </div>
                        }
                        @if (fact.artifactType === 'Page.A11yReport') {
                          <div class="fact a11-report">
                            <button pButton type="button" (click)="openArtifact(fact)" label="Open Report"></button>
                          </div>
                        }
                        @if (fact.artifactType === 'DOM.NLPLayoutTreeAnalysis') {
                          <div class="fact nlp-report">
                            <button pButton type="button" (click)="openArtifact(fact)" label="Open Report"></button>
                          </div>
                        }
                        @if (fact.artifactType === 'Page.ContentAnalysis' || fact.artifactType === 'Mobile.AccessibilityAnalysis') {
                          <div class="fact nlp-report">
                            <button pButton type="button" (click)="openArtifact(fact)" label="Open Report"></button>
                          </div>
                        }

                      </div>
                    }
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          }
        </div>
      } @else {
        <div class="state-name">Loading...</div>
      }
    </div>
  }
</div>
